import moment from 'moment';
import { PARTNER_BIRTH_DATE } from '../Components/Steps/PartnerData/PartnerData';
import { BIRTH_DATE } from '../Components/Steps/YourDateOfBirth/YourDateOfBirth';
import { LongTermDTO, RetirementDTO } from '../api/useAutomatedAccountsQuery';

export const formatData = (data: LongTermDTO | RetirementDTO) => {
  const dates = [BIRTH_DATE, PARTNER_BIRTH_DATE];

  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => {
      if (dates.includes(key)) {
        return [key, moment(value).format('MM/DD/YYYY')];
      }
      return [key, value];
    }),
  );
};
